import { Injectable, ComponentFactoryResolver, ApplicationRef, Injector, Type, EmbeddedViewRef, ComponentRef, Inject } from '@angular/core';
import { DialogModule } from './dialog.module';
import { DialogComponent } from './dialog.component';
import { DialogInjector } from './dialog-injector';
import { DialogConfig } from './dialog-config';
import { DialogRef } from './dialog-ref';
import { DOCUMENT } from '@angular/common';
import { TranslateService } from 'src/modules/base/services/translate.service';

@Injectable({
  providedIn: DialogModule
})
export class DialogService {
  dialogComponentRef: ComponentRef<DialogComponent>;
  title: any = '';

  constructor(@Inject(DOCUMENT) private document: any, private componentFactoryResolver: ComponentFactoryResolver, private appRef: ApplicationRef, private injector: Injector, private translateService: TranslateService) { }

  public open(componentType: Type<any>, config: DialogConfig) {
    this.translateService.translate(config['title'] ? config['title'] : '').subscribe(trans => {
      if (trans)
        this.title = trans;
      else
        this.title = "";

    });
    this.document.body.classList.add('modal-open');
    const dialogRef = this.appendDialogComponentToBody(config);
    this.dialogComponentRef.instance.size = config['size'];
    this.dialogComponentRef.instance.title = this.title;//config['title'];
    this.dialogComponentRef.instance.closehide = config['closehide'];
    this.dialogComponentRef.instance.className = config['className'];
    // this.dialogComponentRef.instance.ref = config['ref'];
    this.dialogComponentRef.instance.childComponentType = componentType;

    return dialogRef;
  }

  public openWithSelector(baseService,selector, config: DialogConfig) {
    this.translateService.translate(config['title'] ? config['title'] : '').subscribe(trans => {
      if (trans)
        this.title = trans;
      else
        this.title = "";

    });
    this.document.body.classList.add('modal-open');
    const dialogRef = this.appendDialogComponentToBody(config);
    this.dialogComponentRef.instance.size = config['size'];
    this.dialogComponentRef.instance.title = this.title;//config['title'];
    this.dialogComponentRef.instance.closehide = config['closehide'];
    this.dialogComponentRef.instance.className = config['className'];
    this.dialogComponentRef.instance.baseService = baseService;
    this.dialogComponentRef.instance.selector = selector;

    return {"dialogRef":dialogRef,"dialogComponentRef":this.dialogComponentRef};
  }

  private appendDialogComponentToBody(config: DialogConfig) {
    const map = new WeakMap();
    map.set(DialogConfig, config);

    const dialogRef = new DialogRef(this.document);
    map.set(DialogRef, dialogRef);
//    config['ref'] = dialogRef;

    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(DialogComponent);
    const componentRef = componentFactory.create(new DialogInjector(this.injector, map));
    this.appRef.attachView(componentRef.hostView);

    const domElem = (componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
    document.body.appendChild(domElem);

    const sub = dialogRef.afterClosed.subscribe(() => {
      this.removeDialogComponentFromBody(componentRef);
      sub.unsubscribe();
    });

    this.dialogComponentRef = componentRef;

    return dialogRef;
  }

  private removeDialogComponentFromBody(dialogComponentRef: ComponentRef<DialogComponent>) {
    this.appRef.detachView(this.dialogComponentRef.hostView);
    dialogComponentRef.destroy();
  }
}
